import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"
import { gql } from "@apollo/client"

export const cloneRateCard = api(async function cloneRateCard({ id }) {
    return mutate(
        gql`
            mutation CloneRateCard($id: String!) {
                cloneRateCard(id: $id) {
                    id
                    name
                    skillMapId
                    skillMapName
                }
            }
        `,
        { id },
        { returns: "cloneRateCard" }
    )
})
